import React from 'react';
import { Box, makeStyles } from '@material-ui/core';

import Header from '~/components/Header';
import theme from '~/theme';
import Footer from '~/components/Footer';

const useStyles = makeStyles({
  main: {
    // main needs top margin to keep content from being covered by the
    // header, which has responsively changing height
    marginTop: '315px',

    [theme.breakpoints.up('md')]: {
      marginTop: 255,
    },
  },
});

const HeaderFooter: React.FC = ({ children }) => {
  const classes = useStyles();

  return (
    <>
      <Header />
      <Box>
        <div className={classes.main}>{children}</div>
      </Box>
      <Footer />
    </>
  );
};

export default HeaderFooter;
